// Telefon numarası formatlama yardımcı fonksiyonları

/**
 * Telefon numarasını "555 555 55 55" formatına çevirir
 * @param {string} phone - Ham telefon numarası
 * @returns {string} - Formatlanmış telefon numarası
 */
export const formatPhoneDisplay = (phone) => {
  if (!phone) return '';

  // Sadece rakamları al
  const cleaned = phone.replace(/\D/g, '');

  // Başındaki 0'ı kaldır
  const withoutLeadingZero = cleaned.startsWith('0') ? cleaned.slice(1) : cleaned;

  // 10 haneli numara kontrolü
  if (withoutLeadingZero.length === 10) {
    return withoutLeadingZero.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  }

  // Eğer formatlanabilir değilse olduğu gibi döndür
  return withoutLeadingZero;
};

/**
 * Formatlanmış telefon numarasını düz metne çevirir (veritabanı için)
 * @param {string} formattedPhone - "555 555 55 55" formatındaki numara
 * @returns {string} - "5555555555" formatındaki numara
 */
export const formatPhoneForDatabase = (formattedPhone) => {
  if (!formattedPhone) return '';

  // Sadece rakamları al
  const cleaned = formattedPhone.replace(/\D/g, '');

  // Başındaki 0'ı kaldır
  const withoutLeadingZero = cleaned.startsWith('0') ? cleaned.slice(1) : cleaned;

  return withoutLeadingZero;
};

/**
 * Input alanında yazılırken telefon numarasını formatlar
 * @param {string} value - Input'taki değer
 * @returns {string} - Formatlanmış değer
 */
export const formatPhoneInput = (value) => {
  if (!value) return '';

  // Sadece rakamları al
  const cleaned = value.replace(/\D/g, '');

  // Başındaki 0'ı kaldır
  const withoutLeadingZero = cleaned.startsWith('0') ? cleaned.slice(1) : cleaned;

  // Maksimum 10 hane
  const limited = withoutLeadingZero.slice(0, 10);

  // Formatlama
  if (limited.length >= 7) {
    return limited.replace(/(\d{3})(\d{3})(\d{1,2})(\d{0,2})/, (match, p1, p2, p3, p4) => {
      let result = p1;
      if (p2) result += ' ' + p2;
      if (p3) result += ' ' + p3;
      if (p4) result += ' ' + p4;
      return result;
    });
  } else if (limited.length >= 4) {
    return limited.replace(/(\d{3})(\d{1,3})/, '$1 $2');
  } else {
    return limited;
  }
};

/**
 * Telefon numarasının geçerli olup olmadığını kontrol eder
 * @param {string} phone - Kontrol edilecek telefon numarası
 * @returns {boolean} - Geçerli ise true
 */
export const isValidPhone = (phone) => {
  if (!phone) return false;

  const cleaned = formatPhoneForDatabase(phone);

  // 10 haneli olmalı ve 5 ile başlamalı (Türkiye cep telefonu formatı)
  return /^5\d{9}$/.test(cleaned);
};

/**
 * Input change event'i için telefon formatları handler
 * @param {Event} e - Input change event
 * @param {Function} setState - State güncelleme fonksiyonu
 * @param {string} fieldName - State'teki alan adı (varsayılan: 'phone')
 */
export const handlePhoneChange = (e, setState, fieldName = 'phone') => {
  const formattedValue = formatPhoneInput(e.target.value);
  e.target.value = formattedValue;

  setState(prevState => ({
    ...prevState,
    [fieldName]: formatPhoneForDatabase(formattedValue)
  }));
};


// WEBPACK FOOTER //
// ./src/helpers/phoneFormatter.js